import React from 'react';
import { connect } from 'react-redux';
import { UserAvatar } from '../shared/UserAvatar';
import Logger from '../../util/Logger';
import User from '../../models/User';
import AuthorizedCreator from '../../models/User';
import { removeSelfLaunch } from '../../actions/selfLaunchAllowed';
import { BaseDialog } from '../layout/Dialog';
import '../shared/UserAvatar.css';
import './AuthorizedCreators.css';
import Tenant from '../../models/Tenant';
import DateTime from '../../models/DateTime';
import { EnterpriseSettings } from '../../analytics/EnterpriseSettings';

class AuthorizedCreatorListItem extends React.Component {

  handleOnRemoveClicked = (creator) => {
    EnterpriseSettings.removeCreator();
    this.setState({
      removingCreator: creator
    });
  };
  handleRemoveAuthorizedCreator = () => {
    const { user, removeSelfLaunch } = this.props;
    const { removingCreator } = this.state;
    if (removingCreator) {
      removeSelfLaunch(Tenant.getId(User.getTenant(user)),
        AuthorizedCreator.getEmail(removingCreator));
      EnterpriseSettings.removeCreatorConfirmation();
    }
  };
  hideDialog = () => {
    this.setState({
      removingCreator: null
    });
  };

  constructor (props) {
    super(props);

    const { user } = this.props;
    if (!user) {
      Logger.assert('Must pass a User model to AuthorizedCreatorListItem');
    }

    this.state = {
      removingCreator: null
    };
  }

  render () {
    const { creator, removeLoading } = this.props;
    const { removingCreator } = this.state;
    const name = AuthorizedCreator.getDisplayName(creator) || 'Not available';
    return (
      <div className="row creator-list-item list-item">
        <div className="name pr-2">
          { name }
        </div>

        <div className="email">
          <UserAvatar user={ creator } />
        </div>

        <div className="authorized">
          <AuthorizedDate creator={ creator } />
        </div>

        <div className="remove">
          <Remove
            creator={ creator }
            onRemoveClicked={ this.handleOnRemoveClicked }
            disabled={ removeLoading } />
        </div>

        { removingCreator && <BaseDialog
          show={ removingCreator }
          title="Really Remove POPin Creator?"
          body={ (
            <div className="my-3">
              <div className="font-weight-bold">
                Are you sure you want to remove { AuthorizedCreator.getEmail(removingCreator) } ?
              </div>
            </div>
          ) }
          ok="Ok"
          onOk={ this.handleRemoveAuthorizedCreator }
          cancel="Cancel"
          hideDialog={ this.hideDialog }
        /> }
      </div>
    );
  }
}

/**
 * Display the date the creator was authorized
 *
 * @param creator MiniUser object
 * @returns {*} JSX for AddedDate
 * @constructor creator object as named prop
 */
const AuthorizedDate = ({ creator }) => {
  const date = AuthorizedCreator.getHeroAuthorizedDate(creator);
  return (
    <div className="added-date">
      { date ? DateTime.format(date, 'MMM DD, YYYY') : 'Not available' }
    </div>
  );
};

/**
 * Display the remove icon if the admin is not the tenant admin
 *
 * @param admin AccountAdministrator object
 * @param onRemoveClicked Admin removed callback
 * @param disabled is button disabled
 * @returns {*} JSX for Remove
 * @constructor admin object as named prop
 */
const Remove = ({ creator, onRemoveClicked, disabled }) => {

  const handleOnRemoveClicked = ($event, creator, handle) => {
    $event.preventDefault();
    handle(creator);
  };

  return (
    <button
      type="button"
      disabled={ disabled }
      onClick={ e => handleOnRemoveClicked(e, creator, onRemoveClicked) }
      className="btn btn-outline font-size-sm d-flex h-100 float-right remove clickable">
      <i className="material-icons remove-icon text-center m-auto">close</i>
    </button>
  );
};

const mapStateToProps = state => {
  return {
    user: state.user.user,
    removeLoading: state.selfLaunchAllowed.removeLoading
  };
};

export default connect(mapStateToProps, { removeSelfLaunch })(AuthorizedCreatorListItem);
